import { formatDate } from "@/lib/utils";
import { Badge, Text } from "@a7y/tailwind-catalyst";
import { OnboardingStateBadge, Section } from "../shared";
import type { AffiliatePayoutOnboarding } from "../types";

export function PayoutOnboardingTab({
  onboarding,
}: {
  onboarding: AffiliatePayoutOnboarding | null;
}) {
  return (
    <Section title="Payout onboarding">
      <Text className="mb-4 text-sm text-zinc-500 dark:text-zinc-400">
        Read-only mirror of the affiliate's Stripe recipient onboarding. Onboarding is live: the
        affiliate starts it from their portal and these values advance as Stripe reports recipient
        status (<span className="font-mono">not_started</span> →{" "}
        <span className="font-mono">pending</span> → <span className="font-mono">active</span>).
      </Text>
      {onboarding ? (
        <dl className="grid grid-cols-1 gap-x-6 gap-y-3 sm:grid-cols-2">
          <div className="flex flex-col gap-0.5 text-sm">
            <dt className="text-xs font-medium uppercase tracking-wide text-zinc-500 dark:text-zinc-400">
              State
            </dt>
            <dd>
              <OnboardingStateBadge state={onboarding.state} />
            </dd>
          </div>
          <div className="flex flex-col gap-0.5 text-sm">
            <dt className="text-xs font-medium uppercase tracking-wide text-zinc-500 dark:text-zinc-400">
              Stripe recipient id
            </dt>
            <dd className="text-zinc-900 dark:text-zinc-100">
              {onboarding.stripeRecipientId ? (
                <span className="font-mono text-xs">{onboarding.stripeRecipientId}</span>
              ) : (
                <Badge color="zinc">Not created</Badge>
              )}
            </dd>
          </div>
          <div className="flex flex-col gap-0.5 text-sm">
            <dt className="text-xs font-medium uppercase tracking-wide text-zinc-500 dark:text-zinc-400">
              Country
            </dt>
            <dd className="text-zinc-900 dark:text-zinc-100">{onboarding.country || "—"}</dd>
          </div>
          <div className="flex flex-col gap-0.5 text-sm">
            <dt className="text-xs font-medium uppercase tracking-wide text-zinc-500 dark:text-zinc-400">
              Updated
            </dt>
            <dd className="text-zinc-900 dark:text-zinc-100">{formatDate(onboarding.updatedAt)}</dd>
          </div>
        </dl>
      ) : (
        <Badge color="zinc">NOT STARTED</Badge>
      )}
    </Section>
  );
}
